import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { apiRequest, apiPost, apiPut, request } from "../../utils/request";
import { toastr } from "react-redux-toastr";
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  FormGroup,
  Label,
} from "reactstrap";
//import {loadDriverLocations} from '../../actions/driverLocationActions';
import {
  addLocationToNewRun,
  removeLocationToNewRun,
  newRunEdit,
  saveNewRun as reduxSaveNewRun, loadRunSuccess,
} from "../../actions/runActions";
import Run from "../Runs/Run";
import RunModal from "../Runs/RunModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  SHORT_DATE_FORMAT,
  LOCATION_TYPE_DROPOFF_CODE,
  LOCATION_TYPE_BASE_CODE,
  TRUCK_TYPES_CODES,
  CUSTOMER_TYPES_NAMES, IsNullOrUndefined,
} from "../../constants";
import Select from "react-select";
import EditLocationView from "../Location/EditLocationView";
import { mustBeArray } from "../../utils/lib";
import RegionView from "./subcomponents/RegionView.jsx";
import LocationItem from "./subcomponents/LocationItem.jsx";
import RegionSelect from "./subcomponents/RegionSelect.jsx";
import {getIsCollectionRun, getRunFlag} from "../../utils/collectionTypes";

/**
 * @typedef {Object} Region
 * @property {number} id
 * @property {string} name
 */

/**
 * @typedef {Object} Location
 * @property {number} id
 * @property {number} daysSinceLastPickup
 * @property {boolean} isUrgentJob
 * @property {number} distance
 * @property {string} locationName
 * @property {boolean} hasTankPickups
 * @property {boolean} hasTankDropoffs
 * @property {boolean} isInClosedPeriod
 * @property {boolean} isClosedOnDeliveryDate
 * @property {number} capacityLitres
 * @property {string} buildingName
 * @property {string} address
 * @property {object} nextPickupNote
 * @property {number} tanksCapacityLitres
 * @property {number} forecastRate
 * @property {number} actualForPeriod
 * @property {number} actualLastYear
 * @property {number} estimatedToReach
 * @property {number} estimatedToReachPlus7
 * @property {string} customerTypeCode
 * @property {string} customerTypeName
 * @property {number} tinsExpected
 * @property {number} tinsExpectedPlus7
 * @property {string} estimatedToReachDate
 * @property {number} capacityThreshold
 * @property {string} regionName
 * @property {number} regionId
 * @property {object} pendingRunStartDate
 * @property {boolean} isNonBulk
 * @property {string} companyName
 * @property {string} suburb
 * @property {number} latitude
 * @property {number} longitude
 * @property {string} typeName
 * @property {string} typeCode
 * @property {number} percentageOfCapacity
 * @property {number} percentageOfCapacityPlus7
 * @property {number} pickupCalculatedLitres
 * @property {string} fullAddress
 * @property {PotentialPickup} potentialPickup
 * @property {Runs[]} runs
 * @property {any[]} contacts
 * @property {Communications[]} communications
 */

/**
 * @typedef {Object} PotentialPickup
 * @property {any[]} tankRequests
 * @property {number} id
 * @property {number} locationId
 * @property {boolean} isUrgentJob
 * @property {string} locationFullAddress
 * @property {number} locationLatitude
 * @property {number} locationLongitude
 * @property {string} locationTypeCode
 * @property {number} locationImageCount
 * @property {string} clientCompanyName
 * @property {string} locationTypeName
 * @property {boolean} isTinLocation
 * @property {number} calculatedLitres
 * @property {number} expectedTins
 * @property {object} pickupNote
 * @property {LocationCommunications[]} locationCommunications
 * @property {any[]} locationContacts
 * @property {string} dateCreated
 * @property {string} pickupStatusCode
 */
/**
 * @typedef {Object} LocationCommunications
 * @property {number} id
 * @property {string} detail
 * @property {string} communicationType
 * @property {number} locationId
 */
/**
 * @typedef {Object} LocationContacts
 * @property {number} id
 * @property {string} fullName
 * @property {number} locationId
 * @property {any[]} communications
 */
/**
 * @typedef {Object} Runs
 * @property {number} id
 * @property {string} timeStart
 * @property {boolean} isComplete
 * @property {number} locationId
 */
/**
 * @typedef {Object} Contacts
 * @property {number} id
 * @property {string} fullName
 * @property {number} locationId
 * @property {any[]} communications
 */
/**
 * @typedef {Object} Communications
 * @property {number} id
 * @property {string} detail
 * @property {string} communicationType
 * @property {number} locationId
 */

/**
 * @typedef {Object} NewRunItem
 * @property {string} timeStart
 * @property {string} truckId
 * @property {string} driverId
 * @property {string} locationBaseId
 * @property {string} locationDropOffId
 */

/**
 * @typedef {Object} NewRun
 * @property {Location[]} locations
 * @property {NewRunItem} run
 * @property {boolean} saving
 */

/**
 * @typedef {Object} SearchLocationItem
 * @property {Region} region
 * @property {Location[]} locations
 * @property {number} countExceededCapacity
 * @property {boolean=} loaded
 */

const getCalculatedLitres = function (location, timeStart, isCollectionRun) {
  let daysTillNewRun = 1;
  let toReturn = 0;
  if (
    location.pendingRunStartDate &&
    moment(timeStart).isAfter(moment(location.pendingRunStartDate))
  ) {
    daysTillNewRun = moment(location.pendingRunStartDate).diff(
      moment(timeStart),
      "days"
    );
    toReturn = Math.abs(daysTillNewRun) * location.forecastRate;
  } else {
    daysTillNewRun = moment(timeStart).diff(
      moment(moment(location.estimatedToReachDate).format(SHORT_DATE_FORMAT)),
      "days"
    );
    toReturn = daysTillNewRun * location.forecastRate + location.estimatedToReach;
  }
  
  if(isCollectionRun) {
    return toReturn;
  }
  // For deliveries the calculated litres can't be greater than the location capacity
  return toReturn > location.capacityLitres ? location.capacityLitres : toReturn;
};

const setDefaultSearch = function (state) {
  return {
    ...state,
    searchTerm: "",
    searchTinLocations: false,
    searchBulkLocations: true,
    searchBulkCapacityPercentage: "70",
    searchMinTinsExpected: 6,
    searchDaysOutFromDelivery: 5,
    searchIsUrgent: true,
    searchIsAllocated: false,
    searchHasTankDropOffs: false,
    searchHasTankPickups: false,
    searchFreshBibLocations: false,
    searchMinFreshBibs: 6,
    searchFreshBulkLocations: true,
    searchFreshBulkCapacityPercentage: "70",
    searchType: "Collection",
  };
};

class SearchLocationsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      /**
       * @type {SearchLocationItem[]}
       */
      items: [],
      searching: false,
      runSearchOpen: false,
      selectedLocation: {},
      searchingRuns: false,
      searchRuns: [],
      selectedRun: {},
      canSave: true,
      searchRunsAllLocations: false,
      viewRunId: 0,
      viewLocationId: 0,
      searchMode: `1`,
      searchModeOptions: [
        {
          label: "Phone/Name/Suburb",
          value: 1,
        },
        {
          label: "Fill rate",
          value: 2,
        },
        {
          label: "Consumption Rate",
          value: 3,
        },
        {
          label: "Custom",
          value: 4,
        },
      ],
      /**
       * @type {NewRun}
       */
      newRun: { locations: [], run: {} },
      canNewRunSave: true,
      filterOptions: {
        bulkTinsNew: [
          { value: "bulk", label: "Bulk" },
          { value: "tin", label: "Tins" },
          { value: "new", label: "New" },
        ],
      },
      filterTinBulkNew: "bulk,tin,new",
      selectedManagedLocation: null,
      baseLocations: [],
      dropOffLocations: [],
      searchTypesOptions: [
        {
          label: "",
          value: "None",
        },
        {
          label: "Collection",
          value: "Collection",
        },
        {
          label: "Fresh Oil",
          value: "Fresh Oil",
        },
      ],
      searchType: "None",
      params: {},
      searchTerm: "",
      searchTinLocations: false,
      searchBulkLocations: true,
      searchBulkCapacityPercentage: "70",
      searchMinTinsExpected: 6,
      searchDaysOutFromDelivery: 5,
      searchIsUrgent: true,
      searchIsAllocated: false,
      searchHasTankDropOffs: false,
      searchHasTankPickups: false,
      searchFreshBibLocations: false,
      searchMinFreshBibs: 6,
      searchFreshBulkLocations: true,
      searchFreshBulkCapacityPercentage: "70",
      /**
       * @type {import("./subcomponents/RegionSelect.jsx").Option[]}
       */
      searchRegion: [],
      nearbyDistanceMeters: 500,
    };

    this.resetForm = this.resetForm.bind(this);
    this.loadLocations = this.loadLocations.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.toggleRunSearch = this.toggleRunSearch.bind(this);
    this.selectRun = this.selectRun.bind(this);
    this.saveRun = this.saveRun.bind(this);
    this.selectedLocationPickup = this.selectedLocationPickup.bind(this);
    this.selectedLocationUrgent = this.selectedLocationUrgent.bind(this);
    this.performSearch = this.performSearch.bind(this);
    this.openRunModal = this.openRunModal.bind(this);
    this.removeLocation = this.removeLocation.bind(this);
    this.saveNewRun = this.saveNewRun.bind(this);
    this.onEditFieldChange = this.onEditFieldChange.bind(this);
    this.isNewRunValid = this.isNewRunValid.bind(this);
    this.clearNewRun = this.clearNewRun.bind(this);
    this.filteredTrucks = this.filteredTrucks.bind(this);
    this.selectedTruck = this.selectedTruck.bind(this);
    this.fillTruck = this.fillTruck.bind(this);
    this.loadNearbyLocations = this.loadNearbyLocations.bind(this);
    this.filteredLocations = this.filteredLocations.bind(this);
    this.loadManagedLocation = this.loadManagedLocation.bind(this);
    this.loadManagedLocationRuns = this.loadManagedLocationRuns.bind(this);
    this.fetchBaseDropOffLocations = this.fetchBaseDropOffLocations.bind(this);
    this.getResetState = this.getResetState.bind(this);
    this.resetIfIsCollectionRunUpdated = this.resetIfIsCollectionRunUpdated.bind(this);
  }

  loadLocations(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      items: [],
      searching: true,
      filterTinBulkNew: "bulk,tin,new",
      params: {},
    });
    let daysOut =
      moment(this.state.newRun.run.timeStart).format(SHORT_DATE_FORMAT) ==
      moment().format(SHORT_DATE_FORMAT)
        ? 0
        : moment(this.state.newRun.run.timeStart).diff(moment(), "days") + 1;

    let url = "";
    let params = {
      regionIds: this.state.searchRegion.map(x => x.value),
    };

    if (this.state.searchMode === `1`) {
      url = `/api/locations`;
      params.searchTerm = this.state.searchTerm;
      params.daysOutFromDelivery = daysOut;
      params.customerTypes =
        this.state.searchType === "None" ? "" : this.state.searchType;
    } else if (this.state.searchMode === `2`) {
      url = `/api/locations/byfillrate`;
      params.isBulk = this.state.searchBulkLocations;
      params.isTins = this.state.searchTinLocations;
      params.bulkCapacity = this.state.searchBulkCapacityPercentage;
      params.minTins = this.state.searchMinTinsExpected;
      params.daysOutFromCollection = daysOut;
    } else if (this.state.searchMode === `3`) {
      url = `/api/locations/search/consumption-rate`;
      params.isBulk = this.state.searchFreshBulkLocations;
      params.isBib = this.state.searchFreshBibLocations;
      params.bulkCapacity = this.state.searchFreshBulkCapacityPercentage;
      params.minBibs = this.state.searchMinFreshBibs;
      params.daysOutFromCollection = daysOut;
    } else if (this.state.searchMode === `4`) {
      let { searchIsUrgent, searchIsAllocated, searchHasTankDropOffs, searchHasTankPickups } =
        this.state;
      url = `/api/locations/bycustom`;
      params.isUrgent = searchIsUrgent;
      params.isAllocated = searchIsAllocated;
      params.hasTankPickups = searchHasTankPickups;
      params.hasTankDropOffs = searchHasTankDropOffs;
      params.daysOutFromDelivery = daysOut;
      params.customerTypes =
        this.state.searchType === "None" ? "" : this.state.searchType;
    }

    this.setState({
      params,
    });
    request.get(url, { params }).then((x) => {
      if (x.error || x.data.Message) {
        toastr.error(
          `Error while searching locations, error: ${
            x.error ? x.error : x.data.Message
          }`
        );
      } else {
        this.setState({
          items: mustBeArray(x.data.regions).map(y => ({
            ...y,
            loaded: true
          })),
          searching: false,
        });
      }
    });
  }

  loadNearbyLocations(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({ items: [], searching: true });
    let daysOut =
      moment(this.state.newRun.run.timeStart).diff(moment(), "days") + 1;

    let locationIds = "";
    for (let i = 0; i < this.state.newRun.locations.length; i++) {
      if (i > 0) locationIds += ",";  // Only add comma between items
      locationIds += this.state.newRun.locations[i].id;
    }

    let url = `/api/locations/nearby?daysOutFromDelivery=${daysOut}&locationIds=${locationIds}&isTins=${this.state.searchTinLocations}&isBulk=${this.state.searchBulkLocations}&distanceMeters=${this.state.nearbyDistanceMeters}`;

    apiRequest(url).then((x) => {
      if (x.error || x.data.Message) {
        toastr.error(
          `Error while searching locations, error: ${
            x.error ? x.error : x.data.Message
          }`
        );
      } else {
        this.setState({
          items: mustBeArray(x.data.regions).map(y => ({
            ...y,
            loaded: true
          })),
          searching: false,
        });        
      }
    });
  }

  getResetState() {
    return {
      searchTerm: "",
      searching: false,
      items: [],
      searchTinLocations: false,
      searchBulkLocations: true,
      searchBulkCapacityPercentage: "70",
      searchMinTinsExpected: 6,
      searchDaysOutFromDelivery: 5,
      canNewRunSave: true,
      filterTinBulkNew: "bulk,tin,new",
      searchFreshBibLocations: false,
      searchFreshBulkLocations: true,
      searchType: "Collection",
      searchFreshBulkCapacityPercentage: "70",
      searchMinFreshBibs: 6,
      searchRegion: "",
    };
  }

  async resetForm() {
    try {
      // Get all regions and set them like on first load
      const response = await request.get("/api/regions/lookup");
      const allRegions = mustBeArray(response.data).map((x) => ({
        value: x.id,
        label: x.name,
      }));

      this.setState({
        ...this.getResetState(),
        searchRegion: allRegions
      });
    } catch (error) {
      this.setState(this.getResetState());
      toastr.error(`Error while retrieving regions: ${error}`);
    }
    window.scrollTo(0, 0);
  }

  handleOnChange(e, stateCallback, setStateCallback = undefined) {
    //e.preventDefault();
    let x = {};

    if (e.target.type == "checkbox") {
      x[`${e.target.name}`] = e.target.checked;
    } else {
      x[`${e.target.name}`] = e.target.value;
    }

    if (stateCallback !== undefined) {
      x = stateCallback(x);
    }
    this.setState(x, setStateCallback);
  }
  

  toggleRunSearch(evnt, location) {
    if (evnt) {
      evnt.preventDefault();
    }
    let selectedLocation = location ? location : {};
    let runSearchOpen = !this.state.runSearchOpen;

    if (runSearchOpen) {
      this.performSearch(selectedLocation, false);
    } else {
      this.setState({
        runSearchOpen,
        selectedLocation: selectedLocation,
        selectedRun: {},
      });
    }
  }

  performSearch(selectedLocation, allLocations) {
    this.setState({
      searchRuns: [],
      searchingRuns: true,
      runSearchOpen: true,
      selectedRun: {},
      searchRunsAllLocations: allLocations,
    });
    apiPost(
      `/api/runs/forlocation?allLocations=${allLocations}`,
      selectedLocation
    ).then((x) => {
      if (x.error || x.data.Message) {
        this.setState({ searchingRuns: false });
        toastr.error(
          `Error while searching runs, error: ${
            x.error ? x.error : x.data.Message
          }`
        );
      } else {
        const flagType = this.state.searchType==="Collection"? "Collection": "Delivery";
        this.setState({
          searchRuns: [...x.data.runs.filter(y => getRunFlag(y.truckCollectionTypeCode)===flagType)],
          searchingRuns: false,
          selectedLocation: { ...selectedLocation },
        });
      }
    });
  }

  async selectRun(selectedRun) {
    //the potential run needs to be added to the run pickups

    const httpRunResult = await apiRequest(`/api/runs/${selectedRun.id}?hideSmsNoResponse=false`);
        
    if (httpRunResult.error || httpRunResult.data.Message) {
      toastr.error(`Error while fetching runId: ${selectedRun.id} error: ${httpRunResult.error ? httpRunResult.error : httpRunResult.data.Message}`);
      return;
    } 
    
    const run = {...httpRunResult.data};

    const loc = this.state.selectedLocation;
    const pickupNote = run.isCollectionRun ? loc.nextPickupNote : (loc.nextDeliveryPickupNote || loc.nextPickupNote);
    const newPickup = {
      ...loc.potentialPickup,
      pickupNote,
      calculatedLitres: getCalculatedLitres(loc, run.timeStart, run.isCollectionRun),
    };

    let stateRun = { ...run, pickups: [...run.pickups, newPickup] };
    this.setState({ selectedRun: stateRun, canSave: true });
  }

  saveRun() {
    let selectedRun = this.state.selectedRun;

    let runToSave = {
      id: selectedRun.id,
      truckId: selectedRun.truckId,
      driverId: selectedRun.driverId,
      timeStart: selectedRun.timeStart,
      pickups: selectedRun.pickups.map((p) => {
        return p;
        //TODO: Send the whole pickup
        /*return {
          name: p.clientCompanyName,
          id: p.id,
          locationId: p.locationID,
          isUrgentJob: p.isUrgentJob,
          pickupOrder: p.pickupOrder,
        };*/
      }),
      runCustomerType: this.checkIsSearchingType(),
    };
    apiPut(`/api/runs/${runToSave.id}`, runToSave).then((x) => {
      if (x.data) {
        toastr.success("Updated run");
      } else {
        console.log(x);
        toastr.error("An error occurred");
      }
      this.toggleRunSearch();
      this.loadLocations();
    });
  }

  saveNewRun() {
    let selectedRun = this.state.newRun.run;
    let order = 1;
    let baseStart = {
      locationId: selectedRun.locationBaseId,
      isUrgentJob: false,
      isUrgentCollection: false,
      isUrgentDelivery: false,
      pickupOrder: 0,
      id: -1,
    };
    let baseEnd = {
      locationId: selectedRun.locationDropOffId,
      isUrgentJob: false,
      pickupOrder: this.state.newRun.locations.length + 1,
      id: -1,
    };
    let runToSave = {
      id: -1,
      truckId: selectedRun.truckId,
      driverId: selectedRun.driverId,
      timeStart: selectedRun.timeStart,
      pickups: [
        baseStart,
        ...this.state.newRun.locations.map((l) => {
          const isCollection = selectedRun.isCollectionRun;
          const pickupNote = isCollection ? l.nextPickupNote : (l.nextDeliveryPickupNote || l.nextPickupNote);
          return {
            ...l.potentialPickup,
            pickupNote,
            calculatedLitres: getCalculatedLitres(l, selectedRun.timeStart, isCollection),
          };
        }),
        baseEnd,
      ],
      runCustomerType: this.checkIsSearchingType(),
    };

    this.setState({ canNewRunSave: false });
    this.props.dispatch(reduxSaveNewRun(runToSave));
  }

  selectedLocationPickup() {
    if (
      this.state.selectedRun &&
      this.state.selectedRun &&
      this.state.selectedRun.pickups &&
      this.state.selectedLocation
    ) {
      let returnVal = this.state.selectedRun.pickups.find(
        (x) => x.locationID == this.state.selectedLocation.id
      );
      return returnVal ? (
        <small className="text-muted">
          Pickup order #{returnVal.pickupOrder + 1}
        </small>
      ) : (
        <small />
      );
    }
    return <small />;
  }

  selectedLocationUrgent() {
    if (
      this.state.selectedRun &&
      this.state.selectedRun &&
      this.state.selectedRun.pickups &&
      this.state.selectedLocation
    ) {
      let returnVal = this.state.selectedRun.pickups.find(
        (x) => x.locationID == this.state.selectedLocation.id
      );
      return returnVal ? returnVal.isUrgentJob : false;
    }
    return false;
  }  

  openRunModal(e, runId, locationId) {
    e.preventDefault();
    this.setState({ viewRunId: runId, viewLocationId: locationId });
  }

  fetchBaseDropOffLocations() {
    let url = `/api/managelocations?locationTypes=B&locationTypes=D`;
    return apiRequest(url).then((x) => {
      if (x.data) {
        this.setState({
          baseLocations: [
            ...x.data
              .filter(
                (y) => y.locationTypeUniqueCode === LOCATION_TYPE_BASE_CODE
              )
              .map((y) => {
                return { label: y.locationName, value: y.id };
              }),
          ],
          dropOffLocations: [
            ...x.data
              .filter(
                (y) => y.locationTypeUniqueCode === LOCATION_TYPE_DROPOFF_CODE
              )
              .map((y) => {
                return { label: y.locationName, value: y.id };
              }),
          ],
        });
      }
    });
  }

  componentDidMount() {
    let resetState = this.getResetState();

    let newRun = { ...this.props.newRun };
    //any location here should now be removed from state
    let items = this.state.items.map((r) => {
      let region = r;
      region.locations = [
        ...region.locations.filter(
          (x) => newRun.locations.findIndex((n) => n.id === x.id) < 0
        ),
      ];
      return region;
    });

    this.setState({ ...resetState, newRun, items }, () => {
      this.fetchBaseDropOffLocations();
    });
    window.scrollTo(0, 0);
  }

  static getDerivedStateFromProps(props, state) {
    let newRun = { ...props.newRun };

    //any location here should now be removed from state
    let items = state.items.map((r) => {
      let region = r;      
      region.locations = IsNullOrUndefined(region.locations) || region.locations.length === 0 ? [] : [
        ...region.locations.filter(
          (x) => newRun.locations.findIndex((n) => n.id === x.id) < 0
        ),
      ];
      if (props.locations.items.length > 0) {
        region.locations = IsNullOrUndefined(region.locations) || region.locations.length === 0 ? [] :  [
          ...region.locations.map((y) => {
            let returnL = { ...y };
            let found = props.locations.items.find((a) => a.id === y.id);
            if (found) {
              const isDelivery = state.searchType === "Fresh Oil";
              const note = isDelivery ? (found.nextDeliveryPickupNote || found.nextPickupNote) : found.nextPickupNote;
              returnL.nextPickupNote = note;
              returnL.nextDeliveryPickupNote = found.nextDeliveryPickupNote;
              returnL.potentialPickup.pickupNote = note;
            }
            return returnL;
          }),
        ];
      }

      return region;
    });
    return { ...state, newRun, items };
  }

  removeLocation(location) {
    //add to state first in correct region(s)
    this.props.dispatch(removeLocationToNewRun(location));
    let items = this.state.items.map((region) => {
      if (
        region.region.id === location.regionId &&
        region.locations.findIndex((y) => y.id === location.id) < 0
      ) {
        region.locations = [
          ...region.locations,
          location
        ];
      }
      return region;
    });

    this.setState({ items });
  }

  onEditFieldChange(e) {
    let run = { ...this.state.newRun.run };
    run[e.target.name] = e.target.value;
    //this should be done via redux...
    this.props.dispatch(newRunEdit(run));
  }

  round(value, decimals) {
    return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
  }

  isNewRunValid() {
    let { truckId, driverId, locationBaseId, locationDropOffId } =
      this.state.newRun.run;
    return (
      truckId > 0 && driverId > 0 && locationBaseId > 0 && locationDropOffId > 0
    );
  }

  clearNewRun(evnt) {
    if (evnt) {
      evnt.preventDefault();
    }
    for (let i = 0; i < this.state.newRun.locations.length; i++) {
      this.removeLocation(this.state.newRun.locations[i]);
    }
  }

  loadManagedLocation(locationId) {
    let url = `/api/managelocations?locationId=${locationId}`;
    return apiRequest(url).then((x) => {
      if (x.data.length == 1) {
        this.setState({ selectedManagedLocation: x.data[0] });
      }
    });
  }

  loadManagedLocationRuns(locationId, currentCount) {
    let setValue = (val) => {
      this.setState({
        items: [...this.state.items].map((y) => {
          let r = { ...y };
          r.locations = [...r.locations].map((z) => {
            let rr = z;
            if (rr.id === locationId) {
              rr.runs = val;
            }
            return rr;
          });
          return r;
        }),
      });
    };

    if (currentCount > 0) {
      setValue([]);
    } else {
      apiRequest(`/api/managelocations/runhistory/${locationId}`).then((x) => {
        setValue(x.data);
      });
    }
  }

  checkIsSearchingType() {
    if (((this.state.searchMode === `1` || this.state.searchMode === `4`) &&
            this.state.searchType === "Collection") ||
        this.state.searchMode === `2`) {
      return CUSTOMER_TYPES_NAMES.Collection;
    }

    if (((this.state.searchMode === `1` || this.state.searchMode === `4`) &&
        this.state.searchType === "Fresh Oil") ||
    this.state.searchMode === `3`) {
        return CUSTOMER_TYPES_NAMES.FreshOil;
    }
  }

  /**
   *  Filter collection types
      Fill rate – Bulk Collection, Tin Collection and Asset Delivery
      Consumption rate – Bulk Delivery, BIB delivery

      When doing Phone/name/suburb
      Collection type
      Collection – Bulk Collection, Tin Collection and Asset Delivery -
      Delivery – Bulk Delivery, BIB delivery
   */
  filteredTrucks(trucks = this.props.trucks) {
    const { searchMode, searchType } = this.state;

    let isSearchingCollection =
      ((searchMode === `1` || searchMode === `4`) &&
        searchType === "Collection") ||
      searchMode === `2`;
    let isSearchingDelivery =
      ((searchMode === `1` || searchMode === `4`) &&
        searchType === "Fresh Oil") ||
      searchMode === `3`;

    const hasOneInArray = (itemsToCheck = [], searchList = []) => {
      return itemsToCheck.some((x) => searchList.includes(x));
    };

    const filtered = trucks.items.filter((x) => {
      return (
        (isSearchingCollection &&
          hasOneInArray(
            [
              TRUCK_TYPES_CODES.CollectionBulk,
              TRUCK_TYPES_CODES.CollectionTin,
              TRUCK_TYPES_CODES.AssetDelivery,
            ],
            x.collectionTypeCodesArray
          )) ||
        (isSearchingDelivery &&
          hasOneInArray(
            [TRUCK_TYPES_CODES.DeliveryBulk, TRUCK_TYPES_CODES.DeliveryBib],
            x.collectionTypeCodesArray
          ))
      );
    });
    return filtered;
  }

  selectedTruck() {
    let trucks = this.filteredTrucks(this.props.trucks);

    let filtered = trucks.findIndex(
      (x) => x.id == this.state.newRun.run.truckId
    );

    let returnTrucks = filtered >= 0 ? trucks[filtered] : null;

    let supported =
      this.filteredTrucks(this.props.trucks).findIndex(
        (x) => x.id == this.state.newRun.run.truckId
      ) >= 0;

    return {
      supported: supported,
      truck: returnTrucks,
    };
  }

  fillTruck(evnt, locations = [], level = 0) {
    evnt.preventDefault();
    let { truck } = this.selectedTruck();
    let truckCapacity = truck == null ? 0 : truck.capacityLitres;

    let currentCapacity = this.round(
      this.state.newRun.locations.reduce((a, x) => {
        return a + x.estimatedToReach;
      }, 0),
      0
    );
    let countAdded = 0;
    
    mustBeArray(locations).forEach((location) => {
      let expected = location.estimatedToReach;
      let percentage = ((currentCapacity + expected) / truckCapacity) * 100;
    
      if (percentage < level) {
        if (
          ((!location.isTinLocation &&
            truck.collectionTypeCodes.search("B") >= 0) ||
            (location.isTinLocation &&
              truck.collectionTypeCodes.search("T") >= 0)) &&
          !location.isClosedOnDeliveryDate
        ) {
          currentCapacity = currentCapacity + expected;
          countAdded = countAdded + 1;
          this.props.dispatch(addLocationToNewRun(location));
        }
      }
    });
    if (countAdded === 0) {
      toastr.warning(
        `No locations added, either truck full at selected rate or truck doesn't support the collection type`
      );
    } else {
      toastr.success(`Added ${countAdded} locations to new run`);
    }
  }

  filteredLocations(region) {
    return region.locations.filter(
      (x) =>
        (x.isTinLocation && this.state.filterTinBulkNew.includes("tin")) ||
        (!x.isTinLocation && this.state.filterTinBulkNew.includes("bulk")) ||
        ((x.daysSinceLastPickup == undefined ||
          x.daysSinceLastPickup == null) &&
          this.state.filterTinBulkNew.includes("new"))
    );
  }

  getPickupsToComplete = (pickups) => {
    return mustBeArray(
      pickups.filter((o) => !o.isBase && o.pickupStatusCode !== "CREQ")
    ).length;
  };

  /**
   *
   * @param {Region} region
   * @param {Location[]} locations
   */
  handleLoadLocations(region, locations) {
    const { items, ...state } = this.state;
    this.setState({
      ...state,
      items: items.map((x) => {
        if (x.region.id !== region.id) {
          return x;
        }
        return {
          ...x,
          locations,
          loaded: true
        };
      }),
    });
  }

  resetIfIsCollectionRunUpdated(){
    const searchMode = this.checkIsSearchingType();
    const proposedRun = {...this.state.newRun.run, isCollectionRun: searchMode === CUSTOMER_TYPES_NAMES.Collection};    

    if(proposedRun.isCollectionRun !== this.state.newRun.run.isCollectionRun){
      this.setState({
        items: [],
        searching: false,
        selectedLocation: {}
      });
    }
    
    this.props.dispatch(newRunEdit(proposedRun));
  }
  
  render() {
    let { truck, supported } = this.selectedTruck();
    const {timeStart, isCollectionRun} = this.state.newRun.run;
    let expectedLitres = this.round(
      this.state.newRun.locations.reduce((a, x) => {
        //return a + x.estimatedToReach;
        return a + getCalculatedLitres(x, timeStart, isCollectionRun);
      }, 0),
      0
    );
    const { searchTypesOptions, items, searchMode } = this.state;
    const { trucks } = this.props;
    
    let isSearchValid = true;
    let searchInvalidMessage = "";
    
    if(searchMode === `1` && this.state.searchType === "None") {
      isSearchValid = false;
      searchInvalidMessage = "Please select a search type";
    }
    if(searchMode === `4` && ((!this.state.searchIsUrgent &&
            !this.state.searchHasTankDropOffs &&
            !this.state.searchHasTankPickups) ||
        this.state.searchType==="None" )) {
      isSearchValid = false;
      searchInvalidMessage = "Please select at least one custom option and a search type";
    }
    
    return (
      <div>
        <RunModal
          runId={this.state.viewRunId}
          onClosing={() => this.setState({ viewRunId: 0, viewLocationId: 0 })}
          locationId={this.state.viewLocationId}
          account={this.props.account}
          dispatch={this.props.dispatch}
          showPickupImages
        />

        <Modal isOpen={this.state.runSearchOpen} toggle={this.toggleRunSearch}>
          <ModalHeader>
            {this.state.selectedLocation.locationName}
            <br />
            {this.selectedLocationPickup()}
            <br />            
          </ModalHeader>
          <ModalBody>
            <div className="container">
              {!this.state.selectedRun.id && this.state.searchingRuns && (
                <div className="row">
                  <div className="col-md-12">
                    Finding suitable runs... <i className="fa fa-cog fa-spin" />
                  </div>
                </div>
              )}
              {!this.state.selectedRun.id && !this.state.searchingRuns && (
                <div>
                  Search all locations{" "}
                  <label className="switch switch-3d switch-primary">
                    <input
                      type="checkbox"
                      className="switch-input"
                      checked={this.state.searchRunsAllLocations}
                      autoComplete="false"
                      onChange={(e) => {
                        this.performSearch(
                          this.state.selectedLocation,
                          !this.state.searchRunsAllLocations
                        );
                      }}
                    />
                    <span className="switch-label" />
                    <span className="switch-handle" />
                  </label>
                </div>
              )}
              {!this.state.selectedRun.id && !this.state.searchingRuns && (
                <table className="table table-responsive table-sm">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Regions</th>
                      <th>Driver</th>
                      <th>Pickups </th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.searchRuns.length == 0 && (
                      <tr>
                        <td colSpan="5">No runs found</td>
                      </tr>
                    )}
                    {this.state.searchRuns.map((x) => (
                      <tr key={x.id}>
                        <td>{moment(x.timeStart).format("DD/MM/YYYY")}</td>
                        <td>{x.regions}</td>
                        <td>{x.driversFullName}</td>
                        <td>{`${x.completePickupCount}/${x.pickupCount}`}</td>
                        <td>
                          <Button
                            color="primary"
                            onClick={() => this.selectRun(x)}
                          >
                            Select
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {this.state.selectedRun.id && (
                <Run
                  run={this.state.selectedRun}
                  isPickupLite
                  onSaveRun={(run) =>
                    this.setState({ selectedRun: run, canSave: true })
                  }
                  onEnterReOrderRun={(run) => this.setState({ canSave: false })}
                  isMapView
                  isListView={false}
                  isAdmin
                  drivers={this.props.drivers}
                  trucks={this.props.trucks}
                  showEdit={false}
                />
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            {this.state.selectedRun.id && (
              <Button
                color="secondary"
                onClick={() => this.setState({ selectedRun: {} })}
              >
                <i className="fa fa-chevron-left" />
              </Button>
            )}
            &nbsp;
            {this.state.selectedRun.id && this.state.canSave && (
              <Button color="primary" onClick={this.saveRun}>
                Save Run
              </Button>
            )}
            &nbsp;
            <Button color="secondary" onClick={this.toggleRunSearch}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.selectedManagedLocation != null}
          style={{ minWidth: "800px" }}
        >
          <ModalBody>
            {this.state.selectedManagedLocation && (
              <EditLocationView
                account={this.props.account}
                locationId={this.state.selectedManagedLocation.id}
                showIsUrgent={false}
                onSelectClient={() => {}}
                onComplete={(saved) => {
                  this.setState({ selectedManagedLocation: null });
                  if (saved) {
                    toastr.warning(
                      `Please refresh the search if you've modified anything except the pickup note`
                    );
                  }
                }}
              />
            )}
          </ModalBody>
        </Modal>

        <div className="row">
          <div className="col-md-12">
            <form className="form-horizontal" onSubmit={this.loadLocations}>
              <div className="form-group row">
                <label className="col-md-2 form-control-label" htmlFor="mode">
                  Mode
                </label>
                <div className="col-md-6">
                  <select
                    className="form-control custom-select"
                    onChange={(e) => this.handleOnChange(e, undefined, this.resetIfIsCollectionRunUpdated)}
                    value={searchMode}
                    name="searchMode"
                  >
                    {this.state.searchModeOptions.map((x) => (
                      <option key={x.value} value={x.value}>
                        {x.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {(searchMode === `1` || searchMode === `4`) && (
                <div className="form-group row">
                  <label
                    className="col-md-2 form-control-label"
                    htmlFor="searchType"
                  >
                    Type
                  </label>
                  <div className="col-md-6">
                    <select
                      className="form-control custom-select"
                      value={this.state.searchType}
                      onChange={(e) => this.handleOnChange(e, undefined, this.resetIfIsCollectionRunUpdated)}
                      name="searchType"
                    >
                      {searchTypesOptions.map((x) => (
                        <option key={x.value} value={x.value}>
                          {x.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              {searchMode === `1` && (
                <div className="form-group row">
                  <label
                    className="col-md-2 form-control-label"
                    htmlFor="searchTerm"
                  >
                    Phone/Name/Suburb
                  </label>
                  <div className="col-md-6">
                    <Input
                      type="text"
                      onChange={this.handleOnChange}
                      value={this.state.searchTerm}
                      name="searchTerm"
                      placeholder="Location name, phone or suburb"
                    />
                  </div>
                </div>
              )}
              {searchMode === `2` && (
                <div className="form-group row">
                  <label className="col-md-2 form-control-label" htmlFor="mode">
                    Collection
                  </label>
                  <div className="col-md-6">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          onChange={this.handleOnChange}
                          checked={this.state.searchTinLocations}
                          name="searchTinLocations"
                        />{" "}
                        Collection - Tin
                      </Label>
                      &nbsp;
                      <Label check className={"ml-1"}>
                        <Input
                          type="checkbox"
                          onChange={this.handleOnChange}
                          checked={this.state.searchBulkLocations}
                          name="searchBulkLocations"
                        />{" "}
                        Collection - Bulk
                      </Label>
                    </FormGroup>
                  </div>
                </div>
              )}
              {searchMode === `2` &&
                (this.state.searchBulkLocations ||
                  this.state.searchTinLocations) && (
                  <div className="form-group row">
                    <label
                      className="col-md-2 form-control-label"
                      htmlFor="mode"
                    >
                      Thresholds
                    </label>
                    <div className="col-md-6">
                      <FormGroup check>
                        {this.state.searchBulkLocations && (
                          <Label>Min bulk %</Label>
                        )}
                        {this.state.searchBulkLocations && (
                          <Input
                            type="number"
                            onChange={this.handleOnChange}
                            value={this.state.searchBulkCapacityPercentage}
                            name="searchBulkCapacityPercentage"
                          />
                        )}
                        {this.state.searchTinLocations && (
                          <Label>Min tins</Label>
                        )}
                        {this.state.searchTinLocations && (
                          <Input
                            type="number"
                            onChange={this.handleOnChange}
                            value={this.state.searchMinTinsExpected}
                            name="searchMinTinsExpected"
                          />
                        )}
                      </FormGroup>
                    </div>
                  </div>
                )}

              {/* Consumption Rate */}
              {searchMode === `3` && (
                <div className="form-group row">
                  <label className="col-md-2 form-control-label" htmlFor="mode">
                    Delivery
                  </label>
                  <div className="col-md-6">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          onChange={this.handleOnChange}
                          checked={this.state.searchFreshBibLocations}
                          name="searchFreshBibLocations"
                        />{" "}
                        Fresh Oil - BIB
                      </Label>
                      &nbsp;
                      <Label check className={"ml-1"}>
                        <Input
                          type="checkbox"
                          onChange={this.handleOnChange}
                          checked={this.state.searchFreshBulkLocations}
                          name="searchFreshBulkLocations"
                        />{" "}
                        Fresh Oil - Bulk
                      </Label>
                    </FormGroup>
                  </div>
                </div>
              )}
              {searchMode === `3` &&
                (this.state.searchFreshBibLocations ||
                  this.state.searchFreshBulkLocations) && (
                  <div className="form-group row">
                    <label
                      className="col-md-2 form-control-label"
                      htmlFor="mode"
                    >
                      Thresholds
                    </label>
                    <div className="col-md-6">
                      <FormGroup check>
                        {this.state.searchFreshBibLocations && (
                          <Label>Min Bag In Boxes</Label>
                        )}
                        {this.state.searchFreshBibLocations && (
                          <Input
                            type="number"
                            onChange={this.handleOnChange}
                            value={this.state.searchMinFreshBibs}
                            name="searchMinFreshBibs"
                          />
                        )}
                        {this.state.searchFreshBulkLocations && (
                          <Label>Min bulk %</Label>
                        )}
                        {this.state.searchFreshBulkLocations && (
                          <Input
                            type="number"
                            onChange={this.handleOnChange}
                            value={this.state.searchFreshBulkCapacityPercentage}
                            name="searchFreshBulkCapacityPercentage"
                          />
                        )}
                      </FormGroup>
                    </div>
                  </div>
                )}

              {searchMode === `4` && (
                <div className="form-group row">
                  <label className="col-md-2 form-control-label" htmlFor="mode">
                    Include
                  </label>
                  <div className="col-md-6">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          onChange={this.handleOnChange}
                          checked={this.state.searchIsUrgent}
                          name="searchIsUrgent"
                        />{" "}
                        Is Urgent
                      </Label>
                      &nbsp;
                      <Label check className={"ml-1"}>
                        <Input
                          type="checkbox"
                          onChange={this.handleOnChange}
                          checked={this.state.searchIsAllocated}
                          name="searchIsAllocated"
                        />{" "}
                        Is Allocated
                      </Label>
                      <Label check className={"ml-1"}>
                        <Input
                          type="checkbox"
                          onChange={this.handleOnChange}
                          checked={this.state.searchHasTankPickups}
                          name="searchHasTankPickups"
                        />{" "}
                        Has Tank Pickups
                      </Label>
                      <Label check className={"ml-1"}>
                        <Input
                          type="checkbox"
                          onChange={this.handleOnChange}
                          checked={this.state.searchHasTankDropOffs}
                          name="searchHasTankDropOffs"
                        />{" "}
                        Has Tank Drop-Offs
                      </Label>
                    </FormGroup>
                  </div>
                </div>
              )}

              <RegionSelect
                value={this.state.searchRegion}
                onChange={(values) => {
                  this.setState({
                    searchRegion: values
                  });
                }}
              />

              <div className="form-group row">
                <label className="col-md-2 form-control-label" htmlFor="mode">
                  Run date
                </label>
                <div className="col-md-6">
                  <DatePicker
                    onChange={(val) =>
                      this.onEditFieldChange({
                        target: {
                          name: "timeStart",
                          value: val.format("YYYY-MM-DD"),
                        },
                      })
                    }
                    className="form-control"
                    value={moment(this.state.newRun.run.timeStart).format(
                      "YYYY-MM-DD"
                    )}
                    openToDate={moment(this.state.newRun.run.timeStart)}
                    placeholderText="Run date"
                    locale="en-au"
                    name="timeStart"
                    readOnly={false}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  className="col-md-2 form-control-label"
                  htmlFor="truckId"
                >
                  Truck
                </label>
                <div className="col-md-6">
                  <select
                    className="form-control custom-select"
                    value={this.state.newRun.run.truckId}
                    onChange={this.onEditFieldChange}
                    name="truckId"
                  >
                    <option value="-1" />
                    {this.filteredTrucks(trucks).map((d) => (
                      <option value={d.id} key={d.id}>
                        {d.name} ({d.capacityLitres} L)
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-group row">
                <div className="offset-md-2 col-md-10">                  
                  <button
                    type="Submit"
                    className="btn btn-primary"
                    onClick={this.loadLocations}
                    disabled={!isSearchValid}
                  >
                    Search
                  </button>                  
                  &nbsp;
                  <Button color="secondary" onClick={this.resetForm}>
                    Reset
                  </Button>                  
                  { !isSearchValid && (<div style={{color: 'red'}}>{searchInvalidMessage}</div>)}
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">&nbsp;</div>
        </div>
        {this.state.searching && (
          <div className="row">
            <div className="col-md-12">
              Searching... <i className="fa fa-cog fa-spin" />
            </div>
          </div>
        )}
        {!this.state.searching &&
          this.state.items.length == 0 &&
          this.state.searchTerm == "" && (
            <div className="row">
              <div className="col-md-12">
                Please search by location name, phone or suburb, fill rate or
                custom - {this.state.items.length} found
              </div>
            </div>
          )}

        {this.state.newRun.locations.length > 0 && (
          <div className="row">
            <div className="col-md-12">
              <div id={`newRun`} role="tablist" aria-multiselectable="true">
                <div className="card">
                  <div className="card-header" role="tab" id={`newRun_heading`}>
                    <h5 className="mb-0">
                      <a
                        data-toggle="collapse"
                        data-parent={`#newRun`}
                        href={`#newRun_content`}
                        aria-expanded="true"
                        aria-controls={`newRun_content`}
                      >
                        New Run... ({this.state.newRun.locations.length}{" "}
                        locations)
                      </a>

                      <span className="pull-right">
                        <select
                          value={this.state.nearbyDistanceMeters}
                          onChange={(e) => this.setState({ nearbyDistanceMeters: parseInt(e.target.value) })}
                          style={{ marginRight: 8 }}
                        >
                          <option value={500}>500m</option>
                          <option value={750}>750m</option>
                          <option value={1000}>1km</option>
                          <option value={2000}>2km</option>
                          <option value={5000}>5km</option>
                        </select>
                        <a
                          href="#"
                          onClick={this.loadNearbyLocations}
                        >
                          Find nearby locations
                        </a>
                      </span>
                    </h5>
                    {truck != null && (
                      <h5
                        className={
                          truck.capacityLitres > expectedLitres
                            ? ""
                            : "text-danger"
                        }
                      >
                        {!supported ? (
                          <span className="text-danger">Unsupported truck</span>
                        ) : (
                          `${truck.name} ${this.round(
                            truck.capacityLitres,
                            0
                          )}L capacity`
                        )}
                        <span>
                          , expected litres: {expectedLitres}L (
                          {this.round(
                            this.state.newRun.locations.reduce((a, x) => {
                              return a + x.tinsExpected;
                            }, 0),
                            0
                          )}{" "}
                          {searchMode === "3" ||
                          this.state.searchType === "Collection"
                            ? "BIBs"
                            : "tins"}
                          ),{" "}
                          {this.round(
                            (expectedLitres / truck.capacityLitres) * 100,
                            0
                          )}
                          % full
                        </span>
                      </h5>
                    )}

                    {truck == null && (
                      <h5>
                        Expected litres: {expectedLitres}L (
                        {this.round(
                          this.state.newRun.locations.reduce((a, x) => {
                            return a + x.tinsExpected;
                          }, 0),
                          0
                        )}{" "}
                        {searchMode === "3" ||
                        this.state.searchType === "Collection"
                          ? "BIBs"
                          : "tins"}
                        )
                      </h5>
                    )}
                  </div>

                  <div
                    id={`newRun_content`}
                    className="collapse hide"
                    role="tabpanel"
                    aria-labelledby={`newRun_heading`}
                  >
                    <div className="card-block">
                      <div>&nbsp;</div>
                      <div className="form-horizontal">
                        <div className="form-group row">
                          <label
                            className="col-md-1 form-control-label"
                            htmlFor="locationBaseId"
                          >
                            Base
                          </label>
                          <div className="col-md-6">
                            <select
                              className="form-control custom-select"
                              value={this.state.newRun.run.locationBaseId}
                              onChange={this.onEditFieldChange}
                              name="locationBaseId"
                            >
                              <option value="-1" />
                              {this.state.baseLocations.map((d) => (
                                <option value={d.value} key={d.value}>
                                  {d.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label
                            className="col-md-1 form-control-label"
                            htmlFor="locationDropOffId"
                          >
                            Drop Off
                          </label>
                          <div className="col-md-6">
                            <select
                              className="form-control custom-select"
                              value={this.state.newRun.run.locationDropOffId}
                              onChange={this.onEditFieldChange}
                              name="locationDropOffId"
                            >
                              <option value="-1" />
                              {this.state.dropOffLocations.map((d) => (
                                <option value={d.value} key={d.value}>
                                  {d.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label
                            className="col-md-1 form-control-label"
                            htmlFor="driverId"
                          >
                            Driver
                          </label>
                          <div className="col-md-6">
                            <select
                              className="form-control custom-select"
                              value={this.state.newRun.run.driverId}
                              onChange={this.onEditFieldChange}
                              name="driverId"
                            >
                              <option value="-1" />
                              {this.props.drivers.items.map((d) => (
                                <option value={d.id} key={d.id}>
                                  {d.fullName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            className="col-md-1 form-control-label"
                            htmlFor="truckId"
                          >
                            Truck
                          </label>
                          <div className="col-md-6">
                            <select
                              className="form-control custom-select"
                              value={this.state.newRun.run.truckId}
                              onChange={this.onEditFieldChange}
                              name="truckId"
                            >
                              <option value="-1" />
                              {this.filteredTrucks(trucks).map((d) => (
                                <option value={d.id} key={d.id}>
                                  {d.name} ({d.capacityLitres} L)
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            className="col-md-1 form-control-label"
                            htmlFor="select"
                          >
                            Run date
                          </label>
                          <div className="col-md-6">
                            <DatePicker
                              onChange={(val) =>
                                this.onEditFieldChange({
                                  target: {
                                    name: "timeStart",
                                    value: val.format("YYYY-MM-DD"),
                                  },
                                })
                              }
                              className="form-control"
                              value={moment(
                                this.state.newRun.run.timeStart
                              ).format("YYYY-MM-DD")}
                              openToDate={moment(
                                this.state.newRun.run.timeStart
                              )}
                              placeholderText="Run date"
                              locale="en-au"
                              name="timeStart"
                            />
                          </div>
                        </div>
                        {this.isNewRunValid() && this.state.canNewRunSave && truck && (
                          <div className="col-md-6 offset-md-1">
                            <Button color="primary" onClick={this.saveNewRun}>
                              <i className="fa fa-save" />
                              &nbsp;Create Run
                            </Button>
                            &nbsp;
                            {truck.capacityLitres < expectedLitres && (
                              <span className="text-danger">
                                Capacity exceeded!
                              </span>
                            )}
                          </div>
                        )}
                        {!this.isNewRunValid() && (
                          <div className="col-md-12 text-danger small">
                            * Please select a base, drop-off, driver and truck
                          </div>
                        )}
                        {!this.state.canNewRunSave && (
                          <div className="col-md-12 text-danger small">
                            Saving....
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="card-block">
                      <div style={{ marginBottom: "10px" }}>
                        <a
                          data-toggle="collapse"
                          href={`#selectedLocations_locations`}
                          aria-expanded="false"
                          aria-controls={`selectedLocations_locations`}
                        >
                          Selected locations (
                          {this.state.newRun.locations.length})
                        </a>
                        &nbsp;&nbsp;
                        <a href="#" onClick={this.clearNewRun}>
                          <i className="fa fa-ban" /> Clear locations
                        </a>
                      </div>
                      <div
                        className="collapse"
                        id={`selectedLocations_locations`}
                        style={{ marginBottom: "10px" }}
                      >
                        {this.state.newRun.locations.map((x, index) => (
                          <LocationItem
                            key={`newRun-location-${index}`}
                            isSelected={true}
                            location={x}
                            onLoadManagedLocation={this.loadManagedLocation}
                            onOpenRunModal={this.openRunModal}
                            onRemoveLocation={this.removeLocation}                            
                            onToggleRunSearch={this.toggleRunSearch}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {!this.state.searching && this.state.items.length > 0 && (
          <div className="row">
            <div className="col-md-12">
              <Select
                className="col-md-8"
                name="filterBulkTin"
                value={this.state.filterTinBulkNew}
                multi
                simpleValue
                options={this.state.filterOptions.bulkTinsNew}
                onChange={(val) => this.setState({ filterTinBulkNew: val })}
                delimiter=","
                placeholder="Filter by"
              />
              <br />
              <br />

              <div id={`regions`} role="tablist" aria-multiselectable="true">
                {items.map(({ region, locations, loaded }, index) => (
                  <RegionView
                    key={`region-${region.id}-${index}`}
                    region={region}
                    locations={locations}
                    filterTinBulkNew={this.state.filterTinBulkNew}
                    newRun={this.state.newRun}
                    params={this.state.params}
                    onFillTruck={this.fillTruck}
                    allowFetchLocations={!loaded}
                    onLoadLocations={(loaded) =>
                      this.handleLoadLocations(region, loaded)
                    }
                    renderLocation={(location, isSelected, regionName) => (
                      <LocationItem
                        key={`region-${region.id}-${index}-${location.id}`}
                        isSelected={isSelected}
                        location={location}
                        regionName={regionName}
                        onLoadManagedLocation={this.loadManagedLocation}
                        onOpenRunModal={this.openRunModal}
                        onRemoveLocation={this.removeLocation}                        
                        onToggleRunSearch={this.toggleRunSearch}
                      />
                    )}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

SearchLocationsPage.propTypes = {
  newRun: PropTypes.object.isRequired,
  drivers: PropTypes.object.isRequired,
  trucks: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    drivers: state.drivers,
    trucks: state.trucks,
    newRun: state.newRun,
    account: state.account,
    locations: state.locations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchLocationsPage);
